var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2.84999C6.9465 2.84999 2.8499 6.94659 2.8499 12C2.8499 17.0534 6.9465 21.15 11.9999 21.15C17.0533 21.15 21.1499 17.0534 21.1499 12C21.1499 6.94659 17.0533 2.84999 11.9999 2.84999ZM1.1499 12C1.1499 6.0077 6.00761 1.14999 11.9999 1.14999C17.9922 1.14999 22.8499 6.0077 22.8499 12C22.8499 17.9923 17.9922 22.85 11.9999 22.85C6.00761 22.85 1.1499 17.9923 1.1499 12ZM16.702 8.46447L16.1009 9.06551L13.202 11.9645L16.172 14.9345L16.7731 15.5355L15.571 16.7376L14.9699 16.1366L11.9999 13.1666L9.02988 16.1366L8.42883 16.7376L7.22675 15.5355L7.82779 14.9345L10.7978 11.9645L7.89886 9.06551L7.29782 8.46447L8.4999 7.26239L9.10094 7.86343L11.9999 10.7624L14.8989 7.86343L15.4999 7.26239L16.702 8.46447Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3306048bd3c6ad9d61dc515bbeb43a26.svg";
export { ForwardRef as ReactComponent };